function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '');
}

function getHostname() {
  return window.location.hostname;
}

function isLocalHost(hostname: string) {
  return hostname === '' || hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

export function getServerUrl() {
  const explicit = import.meta.env.VITE_ATS_API_URL;
  if (explicit) return trimTrailingSlash(explicit);

  const hostname = getHostname();
  const stagingRegex = /^([^.\s]+)\.staging-talent\.ourlanterns\.com$/;

  if (isLocalHost(hostname)) {
    return import.meta.env.PROD ? 'https://api-prod.ourlanterns.com/api' : 'http://localhost:9090/api';
  }

  if (stagingRegex.test(hostname)) return 'https://api-staging.ourlanterns.com/api';
  if (hostname === 'talent.ourlanterns.com' || hostname === 'app.ourlanterns.com') {
    return 'https://api-prod.ourlanterns.com/api';
  }
  if (hostname === 'app.admissionguard.com') return 'https://api-prod.admissionguard.com/api';

  throw new Error(`Unknown ATS API environment for host "${hostname}". Set VITE_ATS_API_URL.`);
}

export function getWSServerUrl() {
  const explicit = import.meta.env.VITE_ATS_WS_URL;
  if (explicit) return trimTrailingSlash(explicit);

  const hostname = getHostname();
  const stagingRegex = /^([^.\s]+)\.staging-talent\.ourlanterns\.com$/;

  if (isLocalHost(hostname)) {
    return import.meta.env.PROD ? 'https://api-prod.ourlanterns.com' : 'http://localhost:9090';
  }

  if (stagingRegex.test(hostname)) return 'https://api-staging.ourlanterns.com';
  if (hostname === 'talent.ourlanterns.com' || hostname === 'app.ourlanterns.com') {
    return 'https://api-prod.ourlanterns.com';
  }
  if (hostname === 'app.admissionguard.com') return 'https://api-prod.admissionguard.com';

  throw new Error(`Unknown ATS WS environment for host "${hostname}". Set VITE_ATS_WS_URL.`);
}

export function getLegacyAtsUrl() {
  const explicit = import.meta.env.VITE_LEGACY_ATS_URL;
  if (explicit) return trimTrailingSlash(explicit);

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }

  return window.location.origin;
}

export function isAdmissionGuard() {
  return (
    window.location.hostname.includes('admissionguard.com') ||
    window.localStorage.getItem('enable_admission_guard') === 'true'
  );
}
